<template>
	<button class="v-resume-icon-button" :class="className">
		<svg>
			<use :xlink:href="`frontend/src/components_new/b2c/vresume-icon-button/icons.svg#${iconName}`"></use>
		</svg>
	</button>
</template>
<script>
export default {
	props: {
		iconName: {
			type: String,
			default: 'cross'
		},
		className: String
	}
} 
</script>
<style lang="scss" scoped>
.v-resume-icon-button {
	& svg {
		height: 100%;
		width: 100%;
	}
}
</style>